import axios from 'axios'

/**
 * API for getting list of tenants
 */
export const getListOfTenants = async () => {
  const response = await axios.get('tenants')
  return response
}

/**
 * API for switching tenant
 * @param {String} tenantId Tenant Id
 */
export const switchTenant = async (tenantId) => {
  const response = await axios.get(`tenants/switch?tenantId=${tenantId}`)
  return response
}

export const fetchTenantInformation = async () => {
  const response = await axios.get('tenants/info')
  return response
}

export const updateTenant = async (payload) => {
  const response = await axios.put('tenants', payload)
  return response
}

export const getLowCreditReminder = async () => {
  const response = await axios.get('tenants/low-credit-reminder')
  return response
}

export const updateLowCreditReminder = async (payload) => {
  const response = await axios.put('tenants/low-credit-reminder', payload)
  return response
}
